import { MapPinIcon, SplitIcon, VectorSquareIcon } from "lucide-react"
import { DocsUiLink as Link } from "~/docs-data/docs-link"
import type { LucideIcon } from "lucide-react"
import { H1, H2, P, Section } from "~/components/Typography"
import { Card, CardHeader, CardTitle, CardDescription } from "~/components/ui/card"
import { locationTypes } from "~/docs-data/concepts"

const ICON_BY_TYPE: Record<string, LucideIcon> = {
  place: MapPinIcon,
  area: VectorSquareIcon,
  way: SplitIcon,
}

export default function LocationTypesIndex() {
  return (
    <div className="max-w-screen-xl">
      <Section>
        <H1>Location types</H1>
        <P>
          A location type defines the shape of geography a metric describes. There are three:
          places (point-of-interest), areas (regions), and ways (road / route segments). Each
          location type has its own set of metrics, because the methodology and meaningful columns
          differ across them.
        </P>
      </Section>
      <Section>
        <H2>Available types</H2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {locationTypes.map((lt) => {
            const Icon = ICON_BY_TYPE[lt.id]
            return (
              <Card key={lt.id}>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    {Icon && <Icon className="w-5 h-5 text-muted-foreground" />}
                    <Link to={`/docs/concepts/location-types/${lt.id}`} variant="inline">
                      {lt.name}
                    </Link>
                  </CardTitle>
                  <CardDescription>{lt.description}</CardDescription>
                </CardHeader>
              </Card>
            )
          })}
        </div>
      </Section>
    </div>
  )
}
